import  React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";
import training4 from "../static/img/erasmusDays1.jpg";
import training1 from "../static/img/erasmusDays2.jpg";
import training3 from "../static/img/erasmusDays3.jpg";
import training2 from "../static/img/erasmusDays4.jpg";
import training5 from "../static/img/erasmusDays5.jpg";
//import training6 from "../static/img/training6.jpg";

import "./Microcredit.style.scss";

const ErasmusDays: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    return (
        <div style={{marginTop:"30px",marginBottom:"20px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "ERASMUSDAYS-2026" : 
                "ERASMUSDAYS-2026"}
            </h1>
            <p style={{fontWeight:"inherit",fontSize: "20px",margin:"30px 120px 30px 120px",textAlign:"left"}}>
                {en ? (<>
                        &nbsp; &nbsp;On October 14, 2026, at 1:40 PM, the Educational and Research Institute of Ecology,
                         Green Energy, and Sustainable Development hosted a seminar titled "Future Skills in Action:
                          Insights from Erasmus+ Summer Schools and Training Sessions," 
                          held as part of the ERASMUSDAYS-2026 event. <br/>
                        &nbsp; &nbsp;During the meeting, students Daryna Radchenko and Neonila Viktorova, 
                        along with researchers Anastasiia Klieshch and Anna Kot, shared their practical experiences 
                        and personal impressions regarding academic mobility at the University of Catania (Sicily, Italy). 
                        These exchanges took place within the framework of the Erasmus+ project DOMANI "Development of 
                        Micro-credential Ecosystems in Ukraine and Mongolia for a Competitive and Sustainable Green Economy".
                        
                    </>)
                    :
                    (<>
                        &nbsp; &nbsp;14 жовтня 2026 року о 13:40 в ННІ екології, зеленої енергетики та сталого розвитку відбувся семінар на тему 
                        "Навички для майбутнього в дії: досвід літніх шкіл і тренінгів Erasmus+», присвячену заходу ERASMUSDAYS-2026. <br/>
                        &nbsp; &nbsp;В рамках семінару студентки Дарина Радченко і Неоніла Вікторова та молоді науковці Анастасія Клєщ 
                        і Анна Кот поділились практичним досвідом і особистими враженнями від академічної мобільності до 
                        Університету Катанії (Сицилія. Італія) в межах проєкту програми ERASMUS+: DOMANI «Розвиток екосистем 
                        мікрокваліфікацій в Україні та Монголії для конкурентоспроможної та стійкої «зеленої» економіки».
                    </>)
                }
            </p>
            {/*<p style={{textIndent: "2em"}}>*/}
            {/*    This is the second paragraph, which starts on a new line and also has an indent.*/}
            {/*</p>*/}
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px',width:"84%",margin:"0 auto"}}>
                <img src={training1} alt="training" style={{ width: '100%' }} />
                <img src={training3} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={training2} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={training4} alt="training" style={{ width: '100%',height:'100%' }} />
                <img src={training5} alt="training" style={{ width: '100%',height:'100%' }} />
                {/*<img src={training6} alt="training" style={{ width: '100%' }} /> *!/*/}
            </div>
        </div>
    )
}
export default ErasmusDays;